export interface IAbExperiment {
    abGroup: number;
    name: string;
}

export function getCertainExperiment(experiments: IAbExperiment[], experimentName: string) {
  return experiments.find(({ name }) => name === experimentName);
}

export const isAbExperiment = (experiments: IAbExperiment[], experimentName: string) => {
  const experiment = getCertainExperiment(experiments, experimentName);

  return !!experiment && experiment.abGroup !== 0;
};
